import Web3 from 'web3'

import {getProvider} from './provider'

export const getWeb3 = async (): Promise<Web3> => {
  const provider = await getProvider()
  return new Web3(provider)
}
